import React from 'react';
import '../../styles/onboardingFlow/slides/slide3.scss';
import toolIconTop from '../../assets/onboarding/slides/slide3/tool.svg';
import window1 from '../../assets/onboarding/slides/slide3/window1.svg';
import window2 from '../../assets/onboarding/slides/slide3/window2.svg';
import window3 from '../../assets/onboarding/slides/slide3/window3.svg';
import window4 from '../../assets/onboarding/slides/slide3/window4.svg';
import window5 from '../../assets/onboarding/slides/slide3/window5.svg';

const Slide3 = () => {
  return (
    <div className='slide3'>
      {/* Optimization Windows */}
      <div className='slide3__windows'>
        <div className='slide3__window slide3__window--1'>
          <img src={window1} alt='Optimization Window 1' />
        </div>
        <div className='slide3__window slide3__window--2'>
          <img src={window2} alt='Optimization Window 2' />
        </div>
        <div className='slide3__window slide3__window--3'>
          <img src={window3} alt='Optimization Window 3' />
        </div>
        <div className='slide3__window slide3__window--4'>
          <img src={window4} alt='Optimization Window 4' />
        </div>
        <div className='slide3__window slide3__window--5'>
          <img src={window5} alt='Optimization Window 5' />
        </div>
      </div>

      <div className='slide3__content'>
        {/* Main Content */}
        <div className='slide3__main'>
          {/* Title with Icon at the end */}
          <div className='slide3__title'>
            <h1>
              AI Optimize{' '}
              <img
                src={toolIconTop}
                alt='Tool'
                className='slide3__title-icon'
              />
            </h1>
          </div>

          {/* Subtitle */}
          <h2 className='slide3__subtitle'>Fix What Matters</h2>

          {/* Description */}
          <p className='slide3__description'>
            TARA doesn't just report issues, it tells you what to improve and
            how. Get instant, actionable suggestions to boost performance and
            user experience.
          </p>

          {/* Progress Bars */}
          <div className='slide3__progress'>
            <div className='slide3__progress-dot'></div>
            <div className='slide3__progress-dot'></div>
            <div className='slide3__progress-dot slide3__progress-dot--active'></div>
            <div className='slide3__progress-dot'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slide3;
